import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import cx from 'classnames';
import { ConfigService } from "../../../services";
import { isAssetPortrait } from "./file-utils";
import CKImage from "../image";
/**
 * shows the image thumbnail for an upload item
 */

var ItemThumbnail = createComponent({
  displayName: 'ItemThumbnail',
  propTypes: {
    imageSrc: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    metaWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    metaHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    tooltip: PropTypes.string
  },
  defaultProps: {
    metaHeight: null,
    metaWidth: null,
    imageSrc: '',
    tooltip: ''
  },
  render: function render(props) {
    var imageSrc = props.imageSrc;

    var ConsoleKitConfig = _valuesInstanceProperty(ConfigService).call(ConfigService);

    var isPortrait = isAssetPortrait(props.metaWidth, props.metaHeight);
    return /*#__PURE__*/React.createElement("div", {
      className: cx({
        'file-thumbnail-wrapper': !isPortrait,
        'file-thumbnail-wrapper--portrait': isPortrait
      })
    }, imageSrc ? /*#__PURE__*/React.createElement(CKImage, {
      src: imageSrc
    }) : /*#__PURE__*/React.createElement(CKImage, {
      src: ConsoleKitConfig.assetUploader.defaultFileThumbnail
    }));
  }
});
export default ItemThumbnail;
//# sourceMappingURL=item-thumbnail.js.map